import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import SetupMenu from "./SetupMenu";

function AddSettings() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Add New Setting";
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      return;
    }

    const name = form.txtSettingName.value.trim();
    const value = form.txtSettingValue.value.trim();

    if (!name || !value) {
      setValidated(true);
      return;
    }

    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Name: name,
      Value: value,
    };

    axios({
      method: "post",
      url: config.base_url + "Setting/AddSetting",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message || "Setting saved successfully.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          navigate("/Setup/ManageSettings");
        } else {
          toast.error(response.data.status_message || "Failed to save setting.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => {
        setLoading(false);
      });

    setValidated(true);
  };

  return (
    <>
      <SetupMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Setup/SetupDashboard">Settings</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Add New Setting
                  </li>
                </ol>
              </nav>
              <div className="page-title">Add New Setting</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/Setup/ManageSettings"
                  className="button button-white button-icon"
                >
                  Manage Settings
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <div className="form-group mb-3">
                          <label>Setting Name:</label>
                          <input
                            type="text"
                            className="form-control"
                            name="txtSettingName"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="form-group mb-3">
                          <label>Setting Value:</label>
                          <input
                            type="text"
                            className="form-control"
                            name="txtSettingValue"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-2 text-end">
                        <div className="form-group">
                          {loading ? (
                            <Spinner animation="border" role="status" />
                          ) : (
                            <button
                              type="submit"
                              value="Save"
                              className="button button-primary w-100"
                            >
                              Save
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddSettings;

